import React from 'react';
import PropTypes from 'prop-types';
import { List, Map } from 'immutable';
import { injectIntl } from 'react-intl';
import { SearchParams } from '../../utils/searchUtils';
import { clearMetadata } from '../../actions/metaAttach';
import {
  META_ATTACH_VIEW_NONE,
  META_ATTACH_VIEW_MASS_ADD,
  META_ATTACH_VIEW_POPULATE,
  META_ATTACH_VIEW_COPY,
} from '../../constants/metaAttachStates';
import MassMetaUpdate from './MassMetaUpdate';
import MetaPopulate from './MetaPopulate';
import MetaCopy from './MetaCopy';
import CloseIcon from '../Icons/CloseIcon';
import { deselectAll } from '../../actions/umoGallery';

/* MetaAttach is used to switch between two types of metadata updating
 * META_ATTACH_VIEW_ADD -
 *   simple mass metadata edit, displays a list of editable values
 * META_ATTACH_VIEW_POPULATE -
 *   meta/media populate- adds a list of umos to a metatag, usually a record
 * META_ATTACH_VIEW_COPY -
 *  copies all the metadata from a UMO
 */

function MetaAttach({ dispatch, metaAttachState, allMetatags, selectedUMOIDs, searchParams, isSelectAll, selectedLanguage, umoTotal }) {
  const onCancelClick = () => {
    dispatch(clearMetadata());
    dispatch(deselectAll());
  }
  const progressState = metaAttachState.get('state');
  const errorState = metaAttachState.get('error');

  let viewType = null;
  switch (metaAttachState.get('viewType')) {
    case META_ATTACH_VIEW_MASS_ADD:
      viewType = (<MassMetaUpdate
        metaAttachState={progressState}
        metadataToAttach={metaAttachState.get('metadataToAttach').toJS()}
        selectedUMOIDs={selectedUMOIDs}
        searchParams={searchParams}
        isSelectAll={isSelectAll}
        dispatch={dispatch}
        selectedLanguage={selectedLanguage}
      />);
      break;
    case META_ATTACH_VIEW_POPULATE:
      viewType = (<MetaPopulate
        metaAttachState={progressState}
        umo={metaAttachState.get('umo')}
        umoMetadata={metaAttachState.get('umoMetadata')}
        selectedUMOIDs={selectedUMOIDs}
        searchParams={searchParams}
        isSelectAll={isSelectAll}
        dispatch={dispatch}
      />);
      break;
    case META_ATTACH_VIEW_COPY:
      viewType = (<MetaCopy
        metaAttachState={progressState}
        metaAttachError={errorState}
        allMetatags={allMetatags}
        umo={metaAttachState.get('umo')}
        umoMetadata={metaAttachState.get('umoMetadata')}
        selectedUMOIDs={selectedUMOIDs}
        searchParams={searchParams}
        isSelectAll={isSelectAll}
        dispatch={dispatch}
        umoTotal={umoTotal}
      />);
      break;
    case META_ATTACH_VIEW_NONE:
    default:
      viewType = null;
      break;
  }

  return (
    viewType ?
      <div className="meta-attach">
        {viewType}
        <p>
          <CloseIcon width="24" height="24" className="meta-attach__close-button" onClick={onCancelClick} />
        </p>
      </div>
      : null
  );
}

MetaAttach.propTypes = {
  metaAttachState: PropTypes.instanceOf(Map),
  allMetatags: PropTypes.instanceOf(Object),
  dispatch: PropTypes.func,
  selectedUMOIDs: PropTypes.instanceOf(List),
  searchParams: PropTypes.instanceOf(SearchParams),
  isSelectAll: PropTypes.bool,
  umoTotal: PropTypes.number,
};

export default injectIntl(MetaAttach);
